import {
  getLinkToSearchResultPage,
  LocationType,
  MarketingType,
  PropertyKind,
  PropertyType,
} from '@ev/search-api';

import { CombinedSuggestion, SearchFilters } from '@/components/modules';
import { createSearchLink, getExposeUrl, PropertyFilter } from '@/utils';

export const fetchSearchLink = async (
  tenant: string,
  selectedSuggestion: CombinedSuggestion,
  language: string,
  searchFilters: SearchFilters
): Promise<string> => {
  if (selectedSuggestion.isDisplayId) {
    return getExposeUrl(selectedSuggestion.id, language, tenant);
  }

  const propertyFilter: PropertyFilter[] = [
    {
      field: 'marketingType',
      filter: {
        value: searchFilters?.marketingType as MarketingType,
      },
    },
    searchFilters?.kind
      ? {
          field: 'kind',
          filter: {
            value: searchFilters?.kind as PropertyKind,
          },
        }
      : {
          field: 'objectType',
          filter: {
            value: searchFilters?.objectType as PropertyType,
          },
        },
  ];

  const link = await getLinkToSearchResultPage(
    {
      placeId: selectedSuggestion.id as string,
      description: selectedSuggestion.description as string,
      type: selectedSuggestion.type as LocationType,
    },
    {
      filters: propertyFilter,
    }
  );

  return createSearchLink(link, language, tenant) ?? '';
};
